import React from "react";
import Link, { push } from 'gatsby-link';

import LandingHeader from '../components/LandingHeader';
import GetStartedButton from '../components/GetStartedButton';

import styles from '../assets/css/landing.module.css';

class Homepage extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (

            <div className={[ styles.bgBlueGrad ] + ' [ flex flex-col h-screen overflow-y-scroll  ]'}>

                <LandingHeader />

                <div className="landing [ relative ][ flex flex-1 flex-wrap items-center justify-center ][ p-8 mt-10-sh ]">

                    <div className="relative z-10 p-8">

                        <nav className="flex items-center justify-center w-full">

                            <GetStartedButton
                                index={true}
                                text="Young"
                                theme="orange"
                                link="/please-select"
                                img="/assets/images/younger/about-me-younger.png"
                                left={true}
                            />

                            <GetStartedButton
                                index={true}
                                text="Old"
                                theme="blue"
                                img="/assets/images/older/about-me-older.png"
                                link="/please-select"
                                left={false}
                            />

                        </nav>

                        <div className="w-full text-center text-4xl leading-normal mt-8 pt-8">

                            <p className="block text-white">Our job is to keep you safe.</p>
                            <p className="block text-white">So sometimes we have to share what you tell us with other people.</p>

                        </div>

                    </div>

                </div>

            </div>

        )
    }

}

export default Homepage;



// WEBPACK FOOTER //
// ./src/pages/index.js